import React from 'react';

import { NotificationManager } from '@atlas/core';
import { DefaultPopup } from '@atlas/ui';

import { BASE_PATH } from 'common/constants';

const GPayPopup = ({ id }) => {
  const handleClose = React.useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  return (
    <DefaultPopup
      className="qr-modal"
      headerTitle="gpay"
      headerTitlePosition="left"
      onClose={handleClose}
    >
      <div
        className="popup__content gpay"
        style={{ backgroundImage: `url("${BASE_PATH}/static/assets/images/qr-code-bg-gpay.png")` }}
      />
    </DefaultPopup>
  );
};

export default GPayPopup;
